<template>
    <div>
        <div class="goods-item">
            <router-link :to="{ name: 'Product'}">
                <div class="cover">
                    <el-image
                            :src="require('@/assets/images/img.png')"
                            fit="cover"/>
                </div>
                <div class="title">商品名稱商品名稱商品名稱</div>
                <div class="fee">$999</div>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GoodsItem",
        //props: ['list'],
        data() {
            return {
                imgUrl:require('../../../assets/images/img.png')
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
        }
    }
</script>
